/*eslint-disable*/
import React from 'react'
import PropTypes from 'prop-types'
import Row from './Row'
import Group from './Group'

const Contract = ({data=[],...rest}) => {
  return (
      data.length === 1 ? (
        <table className="table table-condensed table-hover table-responsive">
          <tbody>
            <Row {...data[0]} {...rest} />
          </tbody>
        </table>
          ) : <Group {...{data}} {...rest} />
  )
};

Contract.propTypes = {
  data: PropTypes.array
};
Contract.defaultProps = {
  data: []
};

export default Contract;



// WEBPACK FOOTER //
// ./src/components/Contract.jsx